import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { L10N_LOCALE, L10nTranslatePipe } from 'angular-l10n';
import {
  DASHBOARD_LAYOUT_VERSION,
  DashboardGridComponent,
  DashboardLayout,
  provideDashboard,
} from 'src/app/shared/dashboard-grid';
import { DASHBOARD_STATE } from './dashboard.state';
import { DASHBOARD_WIDGETS } from './dashboard-widgets';

export const DASHBOARD_ID = 'dashboard';

const DEFAULT_LAYOUT: DashboardLayout = {
  version: DASHBOARD_LAYOUT_VERSION,
  refresh: { enabled: true, intervalSeconds: 60 },
  widgets: [
    { id: 'open-incidents', type: 'metric', x: 0, y: 0, w: 2, h: 2, settings: { metric: 'openIncidents' } },
    { id: 'alerts-sent', type: 'metric', x: 2, y: 0, w: 2, h: 2, settings: { metric: 'alertsSent' } },
    { id: 'incidents-opened', type: 'metric', x: 4, y: 0, w: 2, h: 2, settings: { metric: 'incidentsOpened' } },
    {
      id: 'emergency-alerts',
      type: 'metric',
      x: 6,
      y: 0,
      w: 2,
      h: 2,
      settings: { metric: 'alertsSent', priority: 'emergency' },
    },
    { id: 'recent-alerts', type: 'recent-alerts', x: 8, y: 0, w: 4, h: 6 },
    { id: 'alerts-map', type: 'alerts-map', x: 0, y: 2, w: 8, h: 4 },
    { id: 'incidents-table', type: 'open-incidents', x: 0, y: 6, w: 8, h: 4 },
    {
      id: 'incident-categories',
      type: 'incident-breakdown',
      x: 8,
      y: 6,
      w: 4,
      h: 4,
      settings: { groupBy: 'category' },
    },
  ],
};

/** HomeComponent shows this instead of the legacy admin home for users with `hickory.enterprise-dashboard`. */
@Component({
  selector: 'app-dashboard',
  template: `
    <app-dashboard-grid>
      <h1 dashboardTitle class="dashboard__title">{{ 'Dashboard.Title' | translate: locale.language }}</h1>
    </app-dashboard-grid>
  `,
  styles: `
    :host {
      display: block;
      padding: 24px;
    }

    .dashboard__title {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
    }
  `,
  imports: [DashboardGridComponent, L10nTranslatePipe],
  providers: [
    provideDashboard({
      id: DASHBOARD_ID,
      defaultLayout: DEFAULT_LAYOUT,
      widgets: DASHBOARD_WIDGETS,
      state: DASHBOARD_STATE,
    }),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent {
  protected readonly locale = inject(L10N_LOCALE);
}
